import { useState } from 'react';
import { IAsset } from '../../../../Interfaces/Asset/IAsset';
import { IAssetCategoryId } from '../../../../Interfaces/Asset/IAssetCategory';
import { IAssetTypeId } from '../../../../Interfaces/Asset/IAssetType';
import { IConfig } from '../../../../Interfaces/IConfig';
import { IDocument } from '../../../../Interfaces/IDocument';
import {
  getEmptyInheritanceRelationshipData,
  IInheritanceRelationshipData,
} from '../../../../Interfaces/IInheritanceRelationshipData';
import { LegalTransactionRelationshipTypeEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipTypeEnum';
import { ILegalTransactionRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { DialogFrame } from '../../../core/DialogFrame';
import {
  useDialogContext,
  withDialogProvider,
} from '../../../core/DialogPresenter/DialogContext';
import { useLegalClientStore } from '../generic/legalClientStore';
import { ISavedRelationshipDialogData } from '../generic/utilities';
import { RestoreProgress } from '../RestoreProgress';
import { SaveProgress } from '../SaveProgress';
import { TestamentAssets } from './slides/TestamentAssets';
import { TestamentMainTestator } from './slides/TestamentMainTestator';
import { TestamentRelatives } from './slides/TestamentRelatives';
import { TestamentSecondaryTestator } from './slides/TestamentSecondaryTestator';
import { TestamentSend } from './slides/TestamentSend';
import { TestamentStart } from './slides/TestamentStart';
import { TestamentSummary } from './slides/TestamentSummary';
import { TestamentUploadTestaments } from './slides/TestamentUploadTestament';
import { LegalTransactionRelationshipRoleEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipRoleEnum';

interface ITestamentDialogProps {
  configObject: IConfig;
}

const mockRelationships: any[] = [
  {
    idRelationship: -1,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Testament,
    idLegalTransaction: -1,
    AssetArray: [
      {
        idAsset: -6117587863873939,
        idAssetType: IAssetTypeId.BankAccount,
        idAssetCategory: IAssetCategoryId.PersonalProperty,
        data: { balance: 123, assetLocation: 'Domestic', notes: 'info' },
        name: 'bankkonto',
      },
      {
        idAsset: -6586577491095306,
        idAssetType: IAssetTypeId.Loan,
        idAssetCategory: IAssetCategoryId.Liabilities,
        data: { amount: 123, notes: '123' },
        name: 'kredit',
      },
    ],
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Testator,
        idRelationship: -1,
        FirstName: 'Testator',
        LastName: 'Testatorson',
        data: {
          type: 'testament',
          testamentRole: 'mainTestator',
          birthRegistrationNumber: '123',
          birthRegistryOffice: 'Berlin',
        },
      },
      {
        idLegalClient: -2,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Testator,
        idRelationship: -1,
        FirstName: 'Spouse',
        LastName: 'Testatorson',
        data: {
          type: 'testament',
          testamentRole: 'spouse',
          birthRegistryOffice: 'Hamburg',
          birthRegistrationNumber: '456',
        },
      },
    ],
  },
  {
    idRelationship: -2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Marriage,
    data: { type: 'marriage', divorceDate: null },
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -2,
        data: { type: 'spouse' },
      },
      {
        idLegalClient: -2,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -2,
        data: { type: 'spouse' },
      },
    ],
  },
  {
    idRelationship: -3,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Family,
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -3,
      },
      {
        idLegalClient: -2,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -3,
      },
      {
        idLegalClient: -3,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -3,
      },
      {
        idLegalClient: -4,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -3,
      },
    ],
  },
  {
    idRelationship: -4,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Family,
    Members: [
      {
        idLegalClient: -4,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -4,
      },
      {
        idLegalClient: -6,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -4,
      },
      {
        idLegalClient: -5,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -4,
      },
    ],
  },
  {
    idRelationship: -5,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Marriage,
    data: { type: 'marriage', divorceDate: '1980-02-01' },
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -5,
        data: { type: 'spouse' },
      },
      {
        idLegalClient: -7,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -5,
        data: { type: 'spouse' },
      },
    ],
  },
  {
    idRelationship: -6,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Marriage,
    data: { type: 'marriage', divorceDate: '1981-02-01' },
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -5,
        data: { type: 'spouse' },
      },
      {
        idLegalClient: -8,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Spouse,
        idRelationship: -5,
        data: { type: 'spouse' },
      },
    ],
  },
  {
    idRelationship: -7,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Family,
    data: {},
    Members: [
      {
        idLegalClient: -1,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -7,
        data: {},
      },
      {
        idLegalClient: -7,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
        idRelationship: -7,
        data: {},
      },
      {
        idLegalClient: -9,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -7,
        data: {},
      },
      {
        idLegalClient: -10,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -7,
        data: {},
      },
      {
        idLegalClient: -11,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Child,
        idRelationship: -7,
        data: {},
      },
    ],
  },
  {
    idRelationship: -743397,
    idRelationshipType:
      LegalTransactionRelationshipTypeEnum.InheritanceProvision,
    RelationshipType: '',
    isActiveRelationship: true,
    companyFormationLegalTransaction: null,
    isCompanyFormation: false,
    data: { type: 'inheritance', provisionNotes: 'bestimung' },
    syncWithArnoTop: false,
    Created: '2025-12-23T01:34:59.782Z',
    Updated: '2025-12-23T01:34:59.782Z',
    Members: [
      {
        idLegalClient: -7,
        idRelationship: -743397,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Inheritor,
        idLegalClientRelationship: -1,
        isActiveLegalClientRelationship: true,
        data: { type: 'inheritor', provisionNotes: 'lc notiz 2' },
        FirstName: 'The',
        LastName: 'Ex',
        LegalTransactionArray: [],
        LegalClient: {},
      },
    ],
    DocumentArray: [],
    RealEstateArray: [],
    PartnerIdentifiers: [],
    AssetArray: [
      {
        idAsset: -6117587863873939,
        idAssetType: 2,
        idAssetCategory: 1,
        data: { balance: 123, assetLocation: 'Domestic', notes: 'info' },
        name: '123',
      },
    ],
  },
  {
    idRelationship: -686363,
    idRelationshipType:
      LegalTransactionRelationshipTypeEnum.InheritanceProvision,
    RelationshipType: '',
    isActiveRelationship: true,
    companyFormationLegalTransaction: null,
    isCompanyFormation: false,
    data: { type: 'inheritance', provisionNotes: 'bestimmung verbindlichkeit' },
    syncWithArnoTop: false,
    Created: '2025-12-23T01:36:01.661Z',
    Updated: '2025-12-23T01:36:01.661Z',
    Members: [
      {
        idLegalClient: -2,
        idRelationship: -686363,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Inheritor,
        idLegalClientRelationship: -1,
        isActiveLegalClientRelationship: true,
        data: { type: 'inheritor', provisionNotes: 'spouse notiz' },
        FirstName: 'Spouse',
        LastName: 'Testatorsson',
        LegalTransactionArray: [],
        LegalClient: {},
      },
      {
        idLegalClient: -7,
        idRelationship: -686363,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Inheritor,
        idLegalClientRelationship: -1,
        isActiveLegalClientRelationship: true,
        data: { type: 'inheritor', provisionNotes: 'the ex notiz' },
        FirstName: 'The',
        LastName: 'Ex',
        LegalTransactionArray: [],
        LegalClient: {},
      },
      {
        idLegalClient: -11,
        idRelationship: -686363,
        idRelationshipRole: LegalTransactionRelationshipRoleEnum.Inheritor,
        idLegalClientRelationship: -1,
        isActiveLegalClientRelationship: true,
        data: { type: 'inheritor', provisionNotes: 'child 3 notiz' },
        FirstName: 'child',
        LastName: '3',
        LegalTransactionArray: [],
        LegalClient: {},
      },
    ],
    DocumentArray: [],
    RealEstateArray: [],
    PartnerIdentifiers: [],
    AssetArray: [
      {
        idAsset: -6586577491095306,
        idAssetType: 4,
        idAssetCategory: 3,
        data: { amount: 456, notes: 'angabe verbindlichkeit' },
        name: 'kredit',
      },
    ],
  },
];

type ISavedTestamentData =
  ISavedRelationshipDialogData<IInheritanceRelationshipData> & {
    assets: IAsset[];
  };

const TestamentDialog: React.FC<ITestamentDialogProps> = ({ configObject }) => {
  const { goToPage } = useDialogContext();
  const [legalClientArray, putLegalClient] = useLegalClientStore(state => [
    state.legalClientArray,
    state.putLegalClient,
  ]);
  const [assetArray, setAssetArray] = useState<IAsset[]>([
    {
      idAsset: -6117587863873939,
      idAssetType: IAssetTypeId.BankAccount,
      idAssetCategory: IAssetCategoryId.PersonalProperty,
      data: { balance: 123, assetLocation: 'Domestic', notes: 'info' },
      name: 'bankkonto',
    },
    {
      idAsset: -6586577491095306,
      idAssetType: IAssetTypeId.Loan,
      idAssetCategory: IAssetCategoryId.Liabilities,
      data: { amount: 123, notes: '123' },
      name: 'kredit',
    },
  ]);
  const [documentArray, setDocumentArray] = useState<IDocument[]>([]);
  const [testamentData, setTestamentData] = useState(
    getEmptyInheritanceRelationshipData()
  );
  const [relationshipArray, setRelationshipArray] = useState([
    ...mockRelationships,
  ] as ILegalTransactionRelationship[]);

  const restoreSetterFunction = (savedData: ISavedTestamentData) => {
    const { relationshipArray, legalClientArray, data } = savedData;
    setRelationshipArray(relationshipArray);
    legalClientArray.forEach(putLegalClient);

    setTestamentData(data);
    setAssetArray(savedData.assets);
    goToPage(0);
  };
  const dataToSave = (): ISavedTestamentData => {
    return {
      relationshipArray,
      legalClientArray,
      data: testamentData,
      assets: assetArray,
    };
  };

  return (
    <DialogFrame
      configObject={configObject}
      title={'Formular zum Testament'}
      headerButtonArray={[
        <RestoreProgress
          key='testament-import'
          setterFunction={restoreSetterFunction}
        ></RestoreProgress>,
        <SaveProgress
          key='testament-export'
          idLegaltransaction={1}
          getDataToSave={dataToSave}
          filename={'Testament Notarvorgang'}
        ></SaveProgress>,
      ]}
      txt={''}
    >
      <TestamentStart />
      <TestamentUploadTestaments
        documents={documentArray}
        setDocuments={setDocumentArray}
      />
      <TestamentMainTestator
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentSecondaryTestator
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentRelatives
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentAssets
        configObject={configObject}
        assetArray={assetArray}
        setAssetArray={setAssetArray}
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentSummary
        configObject={configObject}
        assetArray={assetArray}
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
        documentArray={documentArray}
      />
      <TestamentSend />
    </DialogFrame>
  );
};

export default withDialogProvider(TestamentDialog);
